import {
  editPaymentData,
  editPaymentMethod,
  editPaymentMethodWithoutRecharge,
  editDueDate,
  getEditAuthorizationPayment
} from '../services/editPaymentDataService'

import types from './types'

const {
  SET_NEW_DATA_VALUE,
  SET_NEW_DUE_DATE,
  GET_EDIT_AUTH_PAYMENT,
  LOCK_EDIT_AUTH_PAYMENT
} = types

export function setNewDataValue(data) {
  return dispatch =>
    editPaymentMethod(data).then(edited => {
      dispatch({
        type: SET_NEW_DATA_VALUE,
        data: data
      })
      return edited
    })
}

export function setNewDataValueWithoutRecharge(data) {
  return dispatch =>
    editPaymentMethodWithoutRecharge(data).then(edited => {
      dispatch({
        type: SET_NEW_DATA_VALUE,
        data: data
      })
      return edited
    })
}

export function setNewDueDate(data) {
  return dispatch =>
    editDueDate(data).then(edited => {
      dispatch({
        type: SET_NEW_DUE_DATE,
        data
      })
    })
}

export function fetchEditPaymentData({ accountPlanId, recharge, payment }) {
  return () => editPaymentData(accountPlanId, recharge, payment).then(resp => resp)
}

export function lockAuthorizationPayment(type) {
  return dispatch =>
    dispatch({
      type: LOCK_EDIT_AUTH_PAYMENT,
      changeType: type,
      authorizations: {
        error: 'Já alterado'
      }
    })
}

export function checkEditAuthorizationPayment(type, accountPlanId) {
  return dispatch =>
    getEditAuthorizationPayment(type, accountPlanId).then(authorizations => {
      return dispatch({
        type: GET_EDIT_AUTH_PAYMENT,
        changeType: type,
        authorizations
      })
    })
}



// WEBPACK FOOTER //
// ./src/alelo-logic/actions/editPaymentData.js